/**
 * 这里处理活动页面快速导航逻辑：
 * 1.上下滚动时实时激活对应导航（初始加载默认激活第一个导航项）；
 * 2.粘性定位生效时动态修改快速导航栏的z-index值（解决跟总导航菜单层级冲突问题）；
 * 3.活动页面快速导航逻辑（多活动 + 单一全局 scroll 监听 + 完整 destroy）
 */
(function () {

  // 手动声明需要启用的活动（新增活动只需在这里加入一项）
  const NAV_CONFIGS = [
    { navSelector: '.christmas-sale-nav', containerSelector: '.christmas-sale-container' },
    { navSelector: '.new-year-nav', containerSelector: '.new-year-container' },
    { navSelector: '.black-friday-nav', containerSelector: '.black-friday-container' },
    { navSelector: '.halloween-sale-nav', containerSelector: '.halloween-sale-container' },
  ];

  // 存放所有 manager（用于统一处理 scroll 和销毁）
  const managers = [];

  // NavManager 工厂（封装单个导航的所有逻辑）
  function createNavManager(navSelector, containerSelector) {
    const navEl = document.querySelector(navSelector);
    const containerEl = document.querySelector(containerSelector);
    const navItems = containerEl ? Array.from(containerEl.querySelectorAll('.nav-item')) : [];

    // 若没有 nav 或 navItems 则仍返回一个轻量 manager（仅提供 handleStickyZIndex / destroy），便于统一调用
    const manager = {
      navEl,
      containerEl,
      navItems,
      currentActiveId: '',
      observer: null,

      setActiveNav(id) {
        if (id === this.currentActiveId) return;
        this.currentActiveId = id;
        this.navItems.forEach(item => {
          item.classList.remove('active');
          if (item.getAttribute('href') === `#${id}`) {
            item.classList.add('active');
          }
        });
      },

      handleStickyZIndex() {
        if (!this.navEl) return;
        requestAnimationFrame(() => {
          const navViewportTop = this.navEl.getBoundingClientRect().top;
          const isStickyActive = navViewportTop <= 20;
          this.navEl.style.zIndex = isStickyActive ? '11' : '9';
        });
      },

      init() {
        // 如果没有 container 或 navItems，则只做 z-index 初始处理（不创建 observer）
        if (!this.containerEl || this.navItems.length === 0) {
          if (this.navEl) this.handleStickyZIndex();
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const id = entry.target.id;
              if (id) this.setActiveNav(id);
            }
          });
        }, {
          root: null,
          rootMargin: '-100px 0px 0px 0px',
          threshold: 0.01
        });

        this.navItems.forEach(item => {
          const href = item.getAttribute('href') || '';
          if (!href || href.charAt(0) !== '#') return;
          const targetId = href.slice(1);
          const targetEl = document.getElementById(targetId);
          if (targetEl) this.observer.observe(targetEl);
        });

        // 初始 z-index 状态与默认激活第一个 nav-item
        this.handleStickyZIndex();
        if (this.navItems.length > 0) {
          const firstHref = this.navItems[0].getAttribute('href') || '';
          if (firstHref && firstHref.charAt(0) === '#') {
            this.setActiveNav(firstHref.slice(1));
          }
        }
      },

      destroy() {
        if (this.observer) {
          this.navItems.forEach(item => {
            const href = item.getAttribute('href') || '';
            if (!href || href.charAt(0) !== '#') return;
            const targetId = href.slice(1);
            const targetEl = document.getElementById(targetId);
            if (targetEl) this.observer.unobserve(targetEl);
          });
          this.observer.disconnect && this.observer.disconnect();
          this.observer = null;
        }

        if (this.navEl) this.navEl.style.zIndex = '';
        this.navItems.forEach(item => item.classList.remove('active'));
        this.currentActiveId = '';
      }
    };

    return manager;
  }

  // 创建并初始化所有 manager（仅创建，不在创建时添加 window.scroll）
  NAV_CONFIGS.forEach(cfg => {
    const m = createNavManager(cfg.navSelector, cfg.containerSelector);
    m.init();
    managers.push(m);
  });

  // 统一的全局 scroll 回调 —— 只注册一次
  const onScroll = () => {
    managers.forEach(m => m.handleStickyZIndex());
  };
  window.addEventListener('scroll', onScroll);

  // 暴露调试与销毁接口（可根据需要移除）
  window.__quickNavManagers__ = {
    managers,
    destroyAll() {
      managers.forEach(m => m.destroy());
      window.removeEventListener('scroll', onScroll);
      delete window.__quickNavManagers__;
    }
  };
})();
